import loadable from "@loadable/component";

import { isProduction } from "@shared/utils";
const ExperimentTester = loadable(() => import("./ExperimentTester"), {
  fallback: null,
});

const LazyExperimentTester = () => {
  if (isProduction()) return null;

  return <ExperimentTester />;
};

export { LazyExperimentTester };
